import { LaravelResponse, PaginatedOptionsFetchConfig, usePaginatedOptions } from "@dgs/core";
import { useEffect } from "react";
import { BaseOption, CheckboxMultiSelect } from "./CheckboxMultiSelect";

interface Props<TIndexResource> {
	name: string;
	empty: string;
	label: string;
	fetchConfig: PaginatedOptionsFetchConfig<TIndexResource, LaravelResponse<TIndexResource[]>>;
	optionsToHide?: BaseOption[];
	getOption: (entity: TIndexResource) => BaseOption;
}

export const PagedCheckboxMultiSelect = <TIndexResource,>({
	fetchConfig,
	label,
	name,
	empty,
	optionsToHide,
	getOption,
}: Props<TIndexResource>) => {
	const loadProps = usePaginatedOptions(fetchConfig);

	useEffect(() => {
		loadProps.handleFirstLoad();
	}, [loadProps]);

	return (
		<CheckboxMultiSelect
			options={(loadProps.options ?? []).map(getOption)}
			label={label}
			name={name}
			endReached={loadProps.onEndReached}
			onSearch={loadProps.onSearch}
			search={loadProps.search}
			loading={loadProps.loading}
			empty={empty}
			optionsToHide={optionsToHide}
		/>
	);
};
